import { toast } from "react-toastify";
import { Bell } from "lucide-react"; // nice modern icons
import "./notification.scss";

interface NotificationParams {
  data: any;
}

export const handleFCMNotification = ({ data }: NotificationParams) => {
  const { title, body, type } = data;

  const toastContent = (
    <div className="flex items-start gap-3">
      <div className="mt-1 text-blue-500">
        <Bell size={18} />
      </div>

      <div className="flex flex-col">
        <span className="font-semibold text-sm text-gray-900">
          {title || "New Notification"}
        </span>
        <span className="text-xs text-gray-600">
          {body || "You have a new update"}
        </span>
      </div>
    </div>
  );

  toast.success(toastContent, {
    className: "admin-toast",
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
   
  });

  const customEvent = new CustomEvent("newNotification", {
    detail: {
      message: body,
    },
  });

  window.dispatchEvent(customEvent);
};
